import axios from "axios";

const link = document.querySelector("link[rel~='icon']");

const domainName = window.location.href.split(".").slice(-2, -1)[0];

let baseUrl = process.env.REACT_APP_BASE_URL;

if (domainName === "bijayfinance") {
  baseUrl = process.env.REACT_APP_BIJAY_BASE_URL;
  link.href = `${process.env.PUBLIC_URL}/bijay-favicon.ico`;

  document.title = "BIJAY FINANCE LMS";

  const setMeta = (selector, attr, value) => {
    const el = document.querySelector(selector);
    if (el) el.setAttribute(attr, value);
  };

  setMeta("meta[name='description']", "content", "BIJAY FINANCE DASHBOARD");
  setMeta("meta[property='og:title']", "content", "BIJAY FINANCE LMS");
  setMeta("meta[property='og:description']", "content", "BIJAY FINANCE DASHBOARD");
  setMeta("meta[property='og:url']", "content", "https://dashboard.bijayfinance.com/");
  setMeta("meta[property='og:image']", "content", `${window.location.origin}/bijay-logo192.png`);
  setMeta("meta[name='twitter:title']", "content", "BIJAY FINANCE LMS");
  setMeta("meta[name='twitter:description']", "content", "BIJAY FINANCE DASHBOARD");
}

const axiosInstance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve()));
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => axiosInstance(originalRequest))
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        await axiosInstance.post('/auth/refresh');
        processQueue(null);
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        window.location.href = '/';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
